const FromArrEditor = [{
		modelvalue: "",
		title: "经销商编号：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 200,
		height: 32,
		disabled: true,
		marginLeft: 25,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
	},
	{
		modelvalue: "",
		title: "经销商名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "text",
		placeholder: "请输入",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 80,
		marginTop: 10,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		event: 'AuthorizedDealerChange'
	},
	{
		modelvalue: "",
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 105,
		marginTop: 10,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		event: 'invClassChange',
		multiple: true,
		collapseTags: true
	},
	{
		modelvalue: "",
		title: "上游经销商：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "",
		placeholder: "请选择",
		width: 210,
		//height: 32,
		disabled: false,
		marginLeft: 15,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		multiple: true,
	},
	{
		title: "是否从公司订货：",
		inputtype: "checkedD",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 55,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		checked: false,
		hidden: true,
	},
	{
		title: "高层审批：",
		inputtype: "checkedD",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		width: 200,
		height: 32,
		disabled: true,
		marginLeft: 100,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		checked: false,
		hidden: false,
	},
	{
		modelvalue: "",
		title: "文件联系人：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "text",
		placeholder: "请输入",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 280,
		marginTop: 6,
		displayVal: "inline-block",
		fontWeightVal: 500,
	},
	{
		modelvalue: "",
		title: "文件联系人电话：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "text",
		placeholder: "请输入",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 0,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
	},
	{
		modelvalue: "",
		title: "文件联系人邮箱：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "text",
		placeholder: "请输入",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 40,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
	},
	{
		modelvalue: "",
		title: "文件收件地址：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "text",
		placeholder: "请输入",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 68,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
	},
	{
		modelvalue: "",
		title: "申请原因：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "text",
		placeholder: "请输入",
		width: 595,
		height: 32,
		disabled: false,
		marginLeft: 40,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
	},
	{
		title: "医院：",
		modelvalue: [],
		inputtype: "selectMultiple",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 22,
		types: "text",
		placeholder: "请选择",
		width: 252,
		// height: 0,
		disabled: false,
		marginLeft: 57,
		marginTop: 20,
		X: true,
		event: "InforSelectChange",
		remoteMethod: 'PublishremoteMethod',
		loading: false,
		options: []
	},
	{
		title: "仅授权不订货：",
		inputtype: "checkedD",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 30,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		checked: false,
		event: "authChange",
	},
	{
		title: "上游二级经销商：",
		modelvalue: [],
		inputtype: "selectMultiple",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 22,
		types: "text",
		placeholder: "请选择",
		width: 252,
		// height: 0,
		disabled: false,
		marginLeft: 57,
		marginTop: 20,
		X: true,
		event: "InforSelectChange",
		remoteMethod: 'lstParentCodesMethod',
		loading: false,
		hidden: true,
		options: []
	},
	{
		modelvalue: "",
		title: "公司负责人：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "text",
		placeholder: "请输入",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 215,
		marginTop: 8,
		displayVal: "inline-block",
		fontWeightVal: 500,
	},
	{
		title: "关联经销商：",
		modelvalue: [],
		inputtype: "selectMultiple",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 22,
		types: "text",
		placeholder: "请选择",
		width: 252,
		disabled: false,
		marginLeft: 57,
		marginTop: 20,
		X: false,
		event: "InforSelectChange",
		remoteMethod: 'lstBOSSCusCodesMethod',
		loading: false,
		hidden: false,
		options: [],
		tooltipText: "若填关联公司，需上传关联申明",
		showTooltip: false
	}
];
export default FromArrEditor;